import {Element} from 'react-scroll'
import styles from './scheduling.module.css'

const days = ['Sunday', 'Monday', 'Tuesday']
const daysJSX = days.map((day, index) => {
    return (
      <div key={index}>
        <h5>
          {day}
        </h5>
      </div>
    )
})

export default function Scheduling() {
    return (
        <Element id="scheduling">
          <div className={styles.availabilityTitle}>
            <h1>Scheduling+</h1>
          </div>
          <h2>Availability</h2>
          <div className={styles.centeredName}>
            <p>
              Currently, I am only available in the mornings (7 AM to 12 Noon) Sunday through Wednesday.
            </p>
          </div>
          <h2>Pricing</h2>
          <div className={styles.centeredName}>
            <p>
              I accept Kaiser health insurance and private pay. I can provide a Superbill for Out of Network reimbursement benefits. I offer sliding scale for those who need it. My standard rates for 50 minute sessions are $140 for individuals and $175 for couples.
            </p>
          </div>
        </Element>
    )
}
